import { serialize } from "../../../helpers/helpers";
import { apiRequest, getSluiceUrl } from "../../../apiHelper/apiRequest";

const nr_list = async params => {
  return apiRequest(
    "/news/list?" + serialize(params),
    {
      'method': "GET"
    },
    'ptp_core'
  );
}

const nr_add = async params => {
  let add_response = await apiRequest(
    "/news/add",
    {
      'method': "POST",
      'body': params
    },
    'ptp_core'
  );

  if (typeof (add_response.id) !== 'undefined' && add_response.id)
    return add_response.id;
  else
    return 0;
}

const nr_update = async params => {
  let add_response = await apiRequest(
    "/news/update",
    {
      'method': "PUT",
      'body': params
    },
    'ptp_core'
  );

  if (typeof (add_response.id) !== 'undefined' && add_response.id)
    return add_response.id;
  else
    return 0;
}

const nr_remove = async (id = 0) => {
  let remove_response = await apiRequest(
    "/news/delete/" + id,
    {
      'method': "DELETE"
    },
    'ptp_core'
  );
  
  if (typeof (remove_response.id) !== 'undefined' && remove_response.id)
    return remove_response.id;
  else
    return 0;
}

const nr_getImageUrl = (image_path = '') => {
  if (String(image_path).trim() === '' || image_path.indexOf('http') === 0)
    return image_path;
  return getSluiceUrl('ptp_core') + "/news/files/" + image_path;
}

const newsRecords = {
  nr_list,
  nr_add,
  nr_update,
  nr_remove,
  nr_getImageUrl,
};
export default newsRecords;